import { UserRole } from '../api/enum/userRole.enum';

export const menuPermission: any = {
	[UserRole.ROLE_WEB_ADMIN]: [
		'/',
		'/user-manage',
		'/user-manage/user-list/*',
		'/user-manage/delete-user-record/*',
		'/staff-manage',
		'/staff-manage/staff-list/*',
		'/staff-manage/delete-staff-record/*',
		'/app-setting',
		'/app-setting/clock-list/*',
		'/app-setting/moment-list/*',
		'/app-setting/notification-list/*',
		'/app-setting/health-list/*',
		'/app-setting/dialog-list/*',
		'/information-manage',
		'/information-manage/emo-support-list/*',
		'/information-manage/faq-list/*',
		'/information-manage/about-us-list/*',
		'/information-manage/information-list/*',
		'/exercise-manage',
		'/exercise-manage/meditation-list/*',
		'/exercise-manage/body-list/*',
		'/exercise-manage/crossover-list/*',
		'/exercise-manage/day21-list/*',
		'/exercise-manage/ding-day21/*',
		'/exercise-manage/top-series/*',
		'/exercise-manage/manage-tag/*',
		'/exercise-manage/major-list/*',
		'/task-manage',
		'/task-manage/activity-list/*',
		'/task-manage/achievement-list/*',
		'/task-manage/treasure-list/*',
		'/task-manage/regular-day-list/*',
		'/task-manage/regular-week-list/*',
		'/task-manage/regular-month-list/*',
		'/task-manage/rule-list/*',
		'/treasury-manage',
		'/treasury-manage/chartlet-list/*',
		'/treasury-manage/wish-list/*',
		'/treasury-manage/stamp-list/*',
		'/treasury-manage/puzzle-list/*',
		'/treasury-manage/gallery-list/*',
		'/treasury-manage/explain/*',

		'/report-manage',
		'/report-manage/report-list/*',
		'/exchange-manage',
		'/exchange-manage/week-treasure/*',
		'/exchange-manage/mystery-box/*',
	],
	[UserRole.ROLE_WEB_STAFF]: [
		'/',
		'/user-manage',
		'/user-manage/user-list/*',
		'/user-manage/delete-user-record/*',
		'/staff-manage',
		'/staff-manage/staff-list/*',
		'/staff-manage/delete-staff-record/*',
		'/app-setting',
		'/app-setting/clock-list/*',
		'/app-setting/moment-list/*',
		'/app-setting/notification-list/*',
		'/app-setting/health-list/*',
		'/app-setting/dialog-list/*',
		'/information-manage',
		'/information-manage/emo-support-list/*',
		'/information-manage/faq-list/*',
		'/information-manage/about-us-list/*',
		'/information-manage/information-list/*',
		'/exercise-manage',
		'/exercise-manage/meditation-list/*',
		'/exercise-manage/body-list/*',
		'/exercise-manage/crossover-list/*',
		'/exercise-manage/day21-list/*',
		'/exercise-manage/ding-day21/*',
		'/exercise-manage/top-series/*',
		'/exercise-manage/manage-tag/*',
		'/exercise-manage/major-list/*',
		'/task-manage',
		'/task-manage/activity-list/*',
		'/task-manage/achievement-list/*',
		'/task-manage/treasure-list/*',
		'/task-manage/regular-day-list/*',
		'/task-manage/regular-week-list/*',
		'/task-manage/regular-month-list/*',
		'/task-manage/rule-list/*',
		'/treasury-manage',
		'/treasury-manage/chartlet-list/*',
		'/treasury-manage/wish-list/*',
		'/treasury-manage/stamp-list/*',
		'/treasury-manage/puzzle-list/*',
		'/treasury-manage/gallery-list/*',
		'/treasury-manage/explain/*',
		'/report-manage',
		'/report-manage/report-list/*',
		'/exchange-manage',
		'/exchange-manage/week-treasure/*',

		'/exchange-manage/mystery-box/*',
	],
};
